const STATUS_LABELS = {
	open: "Abierto",
	opened: "Abierto",
	active: "Activo",
	inactive: "Inactivo",
	scheduled: "Programado",
	completed: "Completado",
	finished: "Finalizado",
	pending: "Pendiente",
	closed: "Cerrado",
	cancelled: "Cancelado",
	failed: "Reprobado",
	revoked: "Revocado",
	passed: "Aprobado",
	draft: "Borrador",
	published: "Publicado",
	confirmed: "Confirmado",
	absent: "Ausente",
};

export function translateStatusLabel(value, fallback = "-") {
	if (value == null || value === "") return fallback;
	const normalized = String(value).trim().toLowerCase();
	return STATUS_LABELS[normalized] || String(value);
}

const STATUS_CHIP_TONES = {
	active: "active",
	open: "active",
	opened: "active",
	completed: "success",
	finished: "success",
	passed: "success",
	confirmed: "success",
	failed: "danger",
	cancelled: "warning",
	revoked: "danger",
	closed: "danger",
	inactive: "danger",
	pending: "warning",
	scheduled: "warning",
	draft: "warning",
	published: "info",
	absent: "neutral",
};

export function getStatusChipClass(value, baseClass = "status-chip") {
	const normalized = String(value || "").trim().toLowerCase();
	const tone = STATUS_CHIP_TONES[normalized] || "neutral";
	return `${baseClass} ${baseClass}--${tone}`;
}
